import { decode } from "./flexiblePolyline";

const FALLBACK_LOCATION = { lat: -23.5475, lon: -46.63611 };
const TTL_SUCESSO = 5 * 60 * 1000;
const TTL_FALLBACK = 60 * 1000;

let cache: { value: { lat: number; lon: number }; expiraEm: number } | null = null;

export const getLocation = (): Promise<{ lat: number; lon: number }> => {
  if (cache && Date.now() < cache.expiraEm) return Promise.resolve(cache.value);

  return new Promise((resolve) => {
    const cacheAndResolve = (value: { lat: number; lon: number }, ttl: number) => {
      cache = { value, expiraEm: Date.now() + ttl };
      resolve(value);
    };

    if (!navigator.geolocation) return cacheAndResolve(FALLBACK_LOCATION, TTL_FALLBACK);

    navigator.geolocation.getCurrentPosition(
      (position) =>
        cacheAndResolve({ lat: position.coords.latitude, lon: position.coords.longitude }, TTL_SUCESSO),
      () => cacheAndResolve(FALLBACK_LOCATION, TTL_FALLBACK),
      { maximumAge: 300000, timeout: 5000 }
    );
  });
};

export const renderLocation = (item?: string, isString = true) => {
    if (!item) {
      return '';
    }
    const d = decode(item);
    const lastIndex = d.polyline[d.polyline.length - 1];

    return isString ? `${lastIndex[0]}, ${lastIndex[1]}` : lastIndex;
  }